import { render, staticRenderFns } from "./supplyMain.vue?vue&type=template&id=b4766fc6&scoped=true"
import script from "./supplyMain.vue?vue&type=script&lang=js"
export * from "./supplyMain.vue?vue&type=script&lang=js"
import style0 from "./supplyMain.vue?vue&type=style&index=0&id=b4766fc6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4766fc6",
  null
  
)

export default component.exports